var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_vm._t("icon"),_vm._t("title",function(){return [_c('h2',{staticClass:"section-header__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }